import { AfterViewInit, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { WINDOW } from '@benefitsui/app/lib/tokens/window';
import { EmployeeService } from './employee.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-employee-page',
  templateUrl: './employee-page.component.html',
  styleUrls: ['./employee-page.component.scss']
})
export class EmployeePageComponent implements AfterViewInit {
  constructor(
    @Inject(WINDOW) private window: Window,
    private employeeService: EmployeeService,
    private cd: ChangeDetectorRef
  ) {
    this.cardHeader$ = this.employeeService.screenName$.pipe(
      map((s) => {
        switch (s) {
          case 'list':
            return 'Search employees';
          case 'add':
            return 'Add employee';
          case 'detail':
            return employeeService.employeeName$.value;
          default:
            return 'Search employees';
        }
      })
    );

    this.componentName$ = this.employeeService.screenName$;
    this.isList = this.employeeService.isList;
  }

  // :  Data members
  cardHeader$: Observable<string>;
  componentName$: Observable<string>;
  isList: boolean;

  ngAfterViewInit() {
    this.cd.detectChanges();
  }

  goAdd() {
    this.employeeService.setComponent('add');
    this.scrollToTop();
  }

  goList() {
    this.employeeService.setComponent('list');
    this.scrollToTop();
  }

  scrollToTop() {
    this.window.scrollTo(0, 0);
  }
}
